<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="订单明细" name="linked">
        <CustomCardTable :card-data="linkedProject" :filterRequestData="filterRequestData" :needRefresh="needRefresh" @row-click="rowClick"/>
    </el-tab-pane>
    <el-tab-pane label="未挂靠订单明细" name="unlinked" v-if="indexname=='invoice'||indexname=='collection'">
        <CustomCardTable :card-data="unlinkedProject" :filterRequestData="filterRequestData" :needRefresh="needRefresh" @row-click="rowClick"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import CustomCardTable from "@/component/Performance/dialog/CustomCardTable";
  export default {
    name: "CustomDetailTabs",
    components: {
        CustomCardTable
    },
    props:{
        needRefresh:{
            type: Number
        },
        column_mapper:{
            type:Object
        },
        filterRequestData:{
            type:Object
        },
        value:{
            type: Boolean,
            default:false,
            required: true
        },
        indexname:{
            type: String,
            default: "",
            required: true
        }
    },
    data() {
        return {
            activeName: "linked",

            linkedProject: {
                key:"project",
                loading:true,
                height:1000,
                type:"card",
                custom:true,//自定义表头k
                //后台自定义
                showColoums: [],
                tableData: []
            },
            unlinkedProject: {
                key:"advance",
                loading:true,
                height:1000,
                type:"card",
                custom:true,//自定义表头k
                //后台自定义
                showColoums: [],
                tableData: []
            },
        };
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
        }
    }
};
</script>